<section mat-dialog-title>
  <span>Remote action settings</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content>
  @if (!isLoading()) {
    <mat-accordion [multi]="false">
      <!--  device list-->
      <mat-expansion-panel
        (opened)="openedIndex.set(0)"
        [disabled]="isEditMode()"
        [expanded]="openedIndex() === 0"
      >
        <mat-expansion-panel-header [class.cursor-default]="isEditMode()">
          <mat-panel-title>
            <h4>Select Device</h4>
          </mat-panel-title>
          <mat-panel-description>{{ selectedDeviceName() }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="px-6 py-2">
          <avs-device-picker
            (selectedDevicesChange)="deviceSelected($event)"
            [apiFilters]="{onlyWithActions:true}"
            [isMultiSelect]="false"
            scrollBlockHeight="110px"
            sessionFiltersId="remote-action-device-selector"
          />
        </div>
      </mat-expansion-panel>

      <!--  Action point list-->
      <mat-expansion-panel
        (opened)="openedIndex.set(1)"
        [disabled]="selectedDeviceName() === null || isEditMode()"
        [expanded]="openedIndex() === 1"
      >
        <mat-expansion-panel-header [class.cursor-default]="isEditMode() || selectedDeviceName() === null">
          <mat-panel-title>
            <h4>Select Action Point</h4>
          </mat-panel-title>
          <mat-panel-description>{{ selectedActionPointName() }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="px-6 pt-2 pb-6">
          @if (selectedDeviceName() !== null) {
            <avs-action-point-picker
              (actionPointSelected)="selectActionPoint($event)"
              [actionPointId]="form.value.remoteDeviceActionPointId"
              [deviceId]="this.selectedDeviceId() || ''"
            />
          }
        </div>
      </mat-expansion-panel>

      <!--  Remote action name-->
      <mat-expansion-panel
        (opened)="openedIndex.set(2)"
        [disabled]="!form.value.remoteDeviceActionPointId"
        [expanded]="openedIndex() === 2"
      >
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h4>Remote Action Name</h4>
          </mat-panel-title>
          <mat-panel-description>{{ form.value.name }}</mat-panel-description>
        </mat-expansion-panel-header>
        <div class="px-6 py-2">
          <form [formGroup]="form">
            <mat-form-field
              class="input-classic"
              appearance="outline"
            >
              <input
                type="text"
                class="w-full"
                #actionName
                formControlName="name"
                matInput
                placeholder="Enter remote action name"
              />
            </mat-form-field>
          </form>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  } @else {
    <ngx-skeleton-loader [theme]="{ height: '100%' }" />
  }

</mat-dialog-content>
<mat-dialog-actions class="pt-2 pb-6 px-8 gap-x-4 flex flex-row justify-between">
  <div>
    @if (isEditMode()) {
      <button
        class="btn-red btn-medium"
        (click)="removeRemoteAction()"
      >
        Delete
      </button>
    }
  </div>
  <div>
    <button
      class="btn-transparent btn-medium"
      mat-dialog-close
    >
      Cancel
    </button>
    <button
      class="btn-green btn-medium"
      (click)="isEditMode() ? updateRemoteAction() : addRemoteAction()"
      [disabled]="form.invalid"
    >
      Save
    </button>
  </div>

</mat-dialog-actions>
